import React, {useEffect, useRef, useState} from "react";
import {Text, Img, Button} from "./..";
import { ethers } from 'ethers'
import { Web3Provider } from '@ethersproject/providers'
import { formatEther } from '@ethersproject/units'

interface Props {
  className?: string;
}
declare global {
  interface Window {
    ethereum: any;
  }
}
export default function Header1({ ...props }: Props) {
  const [userAddress, setUserAddress] = useState('')
  const [balance, setBalance] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [btcUnisatInstalled, setBtcUnisatInstalled] = useState(false)
  const [btcConnected, setBtcConnected] = useState(false)
  const [btcAccounts, setBtcAccounts] = useState<string[]>([])
  const [btcPublicKey, setBtcPublicKey] = useState('')
  const [btcAddress, setBtcAddress] = useState('')
  const [btcBalance, setBtcBalance] = useState({
    confirmed: 0,
    unconfirmed: 0,
    total: 0,
  })
  const [btcNetwork, setBtcNetwork] = useState('testnet')
  // 连接钱包的函数
  const connectWalletHandler = async () => {
    // @ts-ignore
    if (window.ethereum) {
      try {
        // 请求用户授权连接钱包
        // @ts-ignore
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts',
        })
        setUserAddress(accounts[0])
        // 连接成功后获取余额
        getBalance(accounts[0])
      } catch (error) {
        setErrorMessage(error.message)
      }
    } else {
      setErrorMessage('未检测到以太坊浏览器插件，请安装MetaMask！')
    }
  }

  // 获取余额的函数
  const getBalance = async (address) => {
    try {
      // @ts-ignore
      const provider = new ethers.JsonRpcProvider(
          'https://testnet-rpc.merlinchain.io',
      )
      const balanceBigInt = await provider.getBalance(address)
      console.log(balanceBigInt,123)
      const balanceInEth = formatEther(balanceBigInt)
      setBalance(balanceInEth)
    } catch (error) {
      setErrorMessage(error.message)
    }
  }

  const getBtcBasicInfo = async () => {
    const unisat = (window as any).unisat
    const [address] = await unisat.getAccounts()
    setBtcAddress(address)

    const publicKey = await unisat.getPublicKey()
    setBtcPublicKey(publicKey)

    const balance = await unisat.getBalance()
    setBtcBalance(balance)

    const network = await unisat.getNetwork()
    setBtcNetwork(network)
  }

  const btcSelfRef = useRef<{ accounts: string[] }>({
    accounts: [],
  })
  const btcSelf = btcSelfRef.current

  const handleBtcAccountsChanged = (_accounts: string[]) => {
    if (btcSelf.accounts[0] === _accounts[0]) {
      // prevent from triggering twice
      return
    }
    btcSelf.accounts = _accounts
    if (_accounts.length > 0) {
      setBtcAccounts(_accounts)
      setBtcConnected(true)

      setBtcAddress(_accounts[0])

      getBtcBasicInfo()
    } else {
      setBtcConnected(false)
    }
  }

  const handleBtcNetworkChanged = (network: string) => {
    setBtcNetwork(network)
    getBtcBasicInfo()
  }
  const handleAccountsChanged = (accounts: string[]) => {
    if (accounts.length === 0) {
      // 用户已断开连接
      setUserAddress('')
      setBalance('')
    } else {
      // 用户已连接
      setUserAddress(accounts[0])
      getBalance(accounts[0])
    }
  }
  useEffect(() => {
    // 监听钱包连接状态变化
    if (window.ethereum) {
      window.ethereum.on('accountsChanged', handleAccountsChanged)
    }

    return () => {
      // 组件卸载时移除监听器
      if (window.ethereum) {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged)
      }
    }
  }, [])
  useEffect(() => {
    async function checkUnisat() {
      let unisat = (window as any).unisat

      for (let i = 1; i < 10 && !unisat; i += 1) {
        await new Promise((resolve) => setTimeout(resolve, 100 * i))
        unisat = (window as any).unisat
      }

      if (unisat) {
        setBtcUnisatInstalled(true)
        unisat.getAccounts().then((accounts: string[]) => {
          handleBtcAccountsChanged(accounts)
        })

        unisat.on('accountsChanged', handleBtcAccountsChanged)
        unisat.on('networkChanged', handleBtcNetworkChanged)
      } else {
        setBtcUnisatInstalled(false)
      }
    }

    checkUnisat()

    return () => {
      const unisat = (window as any).unisat
      if (unisat) {
        unisat.removeListener('accountsChanged', handleBtcAccountsChanged)
        unisat.removeListener('networkChanged', handleBtcNetworkChanged)
      }
    }
  }, [])

  const satoshiToBtc = (satoshi) => {
    return (satoshi / 100000000).toFixed(8) // 1 BTC = 100,000,000 Satoshi
  }

  if (!btcUnisatInstalled) {
    return (
        <div className="App">
          <header className="App-header">
            <div>
              <Button
                  onClick={() => {
                    window.location.href = "https://unisat.io";
                  }}
              >
                Install Unisat Wallet
              </Button>
            </div>
          </header>
        </div>
    );
  }
  const unisat = (window as any).unisat
  return (
      <header className="flex self-stretch justify-between items-center ml-8">
        <div className="flex sm:flex-col justify-between items-start w-[48%] gap-5">
          <div className="flex justify-between items-start w-[50%] sm:w-full gap-5">
            <div className="flex justify-center items-center w-[300px]">
              <Img
                  src="images/img_vector.svg"
                  alt="vector_one"
                  className="h-[53px]"
              />
              <div className="flex justify-center ml-3 flex-1">
                <div className="flex flex-col items-start gap-[5px]">
                  <div className="flex">
                    <Img
                        src="images/img_vector_gray_100.svg"
                        alt="vector_three"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_gray_100_13x9.svg"
                        alt="vector_five"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/E.svg"
                        alt="vector_seven"
                        className="h-[13px]"
                    />
                  </div>
                  <div className="flex">
                    <Img
                        src="images/img_vector_13x9.svg"
                        alt="vector_nine"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_1.svg"
                        alt="vector_eleven"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_2.svg"
                        alt="vector_thirteen"
                        className="h-[13px] ml-0.5"
                    />
                    <Img
                        src="images/img_vector_3.svg"
                        alt="vector_fifteen"
                        className="h-[13px] ml-0.5"
                    />
                    <Img
                        src="images/img_vector_4.svg"
                        alt="vector"
                        className="h-[13px] ml-0.5"
                    />
                    <Img
                        src="images/img_vector_gray_100.svg"
                        alt="vector_nineteen"
                        className="h-[13px] ml-[5px]"
                    />
                    <Img
                        src="images/img_vector_gray_100_13x11.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_5.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_gray_100_13x8.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/E.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                  </div>
                  <div className="flex">
                    <Img
                        src="images/img_vector_4.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_gray_100_13x11.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                    <Img
                        src="images/img_vector_1.svg"
                        alt="vector"
                        className="h-[13px]"
                    />
                  </div>
                </div>
                <div className="h-[53px] w-[8px] ml-[47px] bg-deep_purple-A200 ml-[48px]" />
              </div>
            </div>
          </div>
          <div className="flex justify-between w-[550px]">
            <a href="/" className="mt-2.5">
              <Text size="xs" as="p">
                Home
              </Text>
            </a>
            <a
                href="https://roundtable-dao.gitbook.io/roundtable-dao/"
                className="mt-2.5"
            >
              <Text size="xs" as="p">
                Docs
              </Text>
            </a>
            <a href="airdrop" className="mt-2.5">
              <Text size="xs" as="p">
                Airdrop
              </Text>
            </a>
          </div>
        </div>
        <div className="flex sm:flex-col justify-between items-center w-[450px] gap-5">
          <div className="flex justify-center w-[44%] sm:w-full">
            <div className="flex justify-around items-center w-[200px]">
              <Img
                  src="images/union.svg"
                  alt="union_one"
                  style={{
                    width: '32px',
                    height: '32px',
                    transform: 'rotate(30deg)',
                    flexShrink: 0,
                  }}
                  className="z-[1] object-cover"
              />
              <a href="#" className="ml-[-9px]">
                <Text size="xs" as="p">
                  Merlin Chain
                </Text>
              </a>
            </div>
          </div>
          <div className="flex justify-center" onClick={connectWalletHandler}>
            {userAddress ? (
                <Text size="xs" as="p">
                  {balance} BTC
                </Text>
            ) : (
                <Text size="ms" as="p">
                  <svg
                      width="277"
                      height="108"
                      viewBox="0 0 277 108"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_0_1)">
                      <path
                          d="M22.5 48C22.5 30.603 36.603 16.5 54 16.5H223C240.397 16.5 254.5 30.603 254.5 48C254.5 65.397 240.397 79.5 223 79.5H54C36.603 79.5 22.5 65.397 22.5 48Z"
                          stroke="url(#paint0_linear_0_1)"
                          shape-rendering="crispEdges"
                      />
                    </g>
                    <path
                        d="M76.7813 54.165C75.9913 54.165 75.2563 54.03 74.5763 53.76C73.9063 53.48 73.3163 53.09 72.8063 52.59C72.3063 52.09 71.9163 51.51 71.6363 50.85C71.3563 50.18 71.2163 49.46 71.2163 48.69C71.2163 47.92 71.3563 47.205 71.6363 46.545C71.9163 45.875 72.3063 45.295 72.8063 44.805C73.3063 44.315 73.8913 43.935 74.5613 43.665C75.2413 43.385 75.9763 43.245 76.7663 43.245C77.6063 43.245 78.3513 43.38 79.0013 43.65C79.6613 43.92 80.2363 44.29 80.7263 44.76L79.1513 46.35C78.8713 46.05 78.5313 45.815 78.1313 45.645C77.7413 45.475 77.2863 45.39 76.7663 45.39C76.3063 45.39 75.8813 45.47 75.4913 45.63C75.1113 45.78 74.7813 46 74.5013 46.29C74.2313 46.58 74.0163 46.93 73.8563 47.34C73.7063 47.75 73.6313 48.2 73.6313 48.69C73.6313 49.19 73.7063 49.645 73.8563 50.055C74.0163 50.465 74.2313 50.815 74.5013 51.105C74.7813 51.395 75.1113 51.62 75.4913 51.78C75.8813 51.94 76.3063 52.02 76.7663 52.02C77.3063 52.02 77.7763 51.935 78.1763 51.765C78.5763 51.595 78.9213 51.36 79.2113 51.06L80.8013 52.65C80.2913 53.12 79.7063 53.49 79.0463 53.76C78.3963 54.03 77.6413 54.165 76.7813 54.165ZM86.7283 54.18C85.9283 54.18 85.1883 54.04 84.5083 53.76C83.8383 53.48 83.2483 53.09 82.7383 52.59C82.2283 52.09 81.8333 51.51 81.5533 50.85C81.2733 50.18 81.1333 49.46 81.1333 48.69C81.1333 47.91 81.2733 47.19 81.5533 46.53C81.8333 45.87 82.2233 45.295 82.7233 44.805C83.2233 44.305 83.8083 43.92 84.4783 43.65C85.1583 43.37 85.8983 43.23 86.6983 43.23C87.4883 43.23 88.2183 43.37 88.8883 43.65C89.5683 43.92 90.1583 44.305 90.6583 44.805C91.1683 45.295 91.5633 45.875 91.8433 46.545C92.1233 47.205 92.2633 47.925 92.2633 48.705C92.2633 49.475 92.1233 50.195 91.8433 50.865C91.5633 51.525 91.1733 52.105 90.6733 52.605C90.1733 53.095 89.5833 53.48 88.9033 53.76C88.2333 54.04 87.5083 54.18 86.7283 54.18ZM86.6983 52.035C87.3283 52.035 87.8783 51.895 88.3483 51.615C88.8283 51.335 89.1983 50.945 89.4583 50.445C89.7183 49.935 89.8483 49.35 89.8483 48.69C89.8483 48.19 89.7733 47.74 89.6233 47.34C89.4733 46.93 89.2583 46.58 88.9783 46.29C88.6983 45.99 88.3633 45.765 87.9733 45.615C87.5933 45.455 87.1683 45.375 86.6983 45.375C86.0683 45.375 85.5133 45.515 85.0333 45.795C84.5633 46.065 84.1983 46.45 83.9383 46.95C83.6783 47.44 83.5483 48.02 83.5483 48.69C83.5483 49.19 83.6233 49.645 83.7733 50.055C83.9233 50.465 84.1333 50.82 84.4033 51.12C84.6833 51.41 85.0183 51.635 85.4083 51.795C85.7983 51.955 86.2283 52.035 86.6983 52.035ZM93.7583 54V43.41H95.4083L96.1133 45.525V54H93.7583ZM101.063 54L94.8233 46.005L95.4083 43.41L101.648 51.405L101.063 54ZM101.063 54L100.433 51.885V43.41H102.788V54H101.063ZM104.833 54V43.41H106.483L107.188 45.525V54H104.833ZM112.138 54L105.898 46.005L106.483 43.41L112.723 51.405L112.138 54ZM112.138 54L111.508 51.885V43.41H113.863V54H112.138ZM115.907 54V43.41H118.262V54H115.907ZM117.707 54V51.96H123.512V54H117.707ZM117.707 49.575V47.61H122.987V49.575H117.707ZM117.707 45.435V43.41H123.437V45.435H117.707ZM129.97 54.165C129.18 54.165 128.445 54.03 127.765 53.76C127.095 53.48 126.505 53.09 125.995 52.59C125.495 52.09 125.105 51.51 124.825 50.85C124.545 50.18 124.405 49.46 124.405 48.69C124.405 47.92 124.545 47.205 124.825 46.545C125.105 45.875 125.495 45.295 125.995 44.805C126.495 44.315 127.08 43.935 127.75 43.665C128.43 43.385 129.165 43.245 129.955 43.245C130.795 43.245 131.54 43.38 132.19 43.65C132.85 43.92 133.425 44.29 133.915 44.76L132.34 46.35C132.06 46.05 131.72 45.815 131.32 45.645C130.93 45.475 130.475 45.39 129.955 45.39C129.495 45.39 129.07 45.47 128.68 45.63C128.3 45.78 127.97 46 127.69 46.29C127.42 46.58 127.205 46.93 127.045 47.34C126.895 47.75 126.82 48.2 126.82 48.69C126.82 49.19 126.895 49.645 127.045 50.055C127.205 50.465 127.42 50.815 127.69 51.105C127.97 51.395 128.3 51.62 128.68 51.78C129.07 51.94 129.495 52.02 129.955 52.02C130.495 52.02 130.965 51.935 131.365 51.765C131.765 51.595 132.11 51.36 132.4 51.06L133.99 52.65C133.48 53.12 132.895 53.49 132.235 53.76C131.585 54.03 130.83 54.165 129.97 54.165ZM137.706 54V43.56H140.061V54H137.706ZM134.391 45.465V43.41H143.376V45.465H134.391ZM149.953 54L146.548 43.41H148.888L151.378 51.555H150.463L152.893 43.41H154.738L157.168 51.555H156.268L158.743 43.41H161.068L157.663 54H155.818L153.373 45.855H154.243L151.798 54H149.953ZM160.375 54L164.575 43.41H166.705L170.86 54H168.37L165.19 45.21H166.045L162.82 54H160.375ZM162.76 52.08V50.16H168.535V52.08H162.76ZM171.981 54V43.41H174.336V54H171.981ZM173.796 54V51.93H179.031V54H173.796ZM180.389 54V43.41H182.744V54H180.389ZM182.204 54V51.93H187.439V54H182.204ZM188.797 54V43.41H191.152V54H188.797ZM190.597 54V51.96H196.402V54H190.597ZM190.597 49.575V47.61H195.877V49.575H190.597ZM190.597 45.435V43.41H196.327V45.435H190.597ZM200.299 54V43.56H202.654V54H200.299ZM196.984 45.465V43.41H205.969V45.465H196.984Z"
                        fill="white"
                    />
                    <defs>
                      <filter
                          id="filter0_d_0_1"
                          x="0"
                          y="0"
                          width="277"
                          height="108"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                      >
                        <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                        />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                        />
                        <feOffset dy="6"/>
                        <feGaussianBlur stdDeviation="11"/>
                        <feComposite in2="hardAlpha" operator="out"/>
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0.0241667 0 0 0 0 0.133016 0 0 0 0 0.2 0 0 0 0.22 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_0_1"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_0_1"
                            result="shape"
                        />
                      </filter>
                      <linearGradient
                          id="paint0_linear_0_1"
                          x1="255"
                          y1="46"
                          x2="22.0063"
                          y2="44.1862"
                          gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#825FF6"/>
                        <stop offset="0.484375" stop-color="#040C15"/>
                        <stop offset="1" stop-color="#8B5EF3"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </Text>
            )}
          </div>
        </div>
      </header>
  );
}
